import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: "3",
  y: "3",
  width: "18",
  height: "18",
  rx: "5",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "4",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "17",
  cy: "7",
  r: "1",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }